import { styled } from '../stitches.config'
import { FiEdit3, FiUser, FiClock, FiToggleLeft, FiToggleRight, FiCalendar, FiRepeat, FiArrowRight} from 'react-icons/fi'

// popup.styles.ts
export const RowBase = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',          // <── identical gap for every row
  }
  

// Add this near your imports or in gridAreas.tsx
export const DesktopOnlyWrapper = styled('div', {
  display: 'block', // Visible by default
  
  // 💀 KILL DISPLAY ON MOBILE
  '@media (max-width: 900px)': {
    display: 'none !important', 
  }
});
  
export const TimelinePopupWrapper = styled('div', {
  position: 'fixed',
  backgroundColor: '#ffffff',
  boxShadow: '$lg',
  // borderRadius: '8px',
  // padding: '0.75rem 0rem ',  // 0.75rem top | 3rem sides | 2rem bottom
  minWidth: '640px',
  maxWidth: '80vw',
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid $elementBackground',
  borderRadius: '16px',


  '@media (max-width: 900px)': {
    // 1. KILL POSITIONING
    // Use !important to override the inline 'style={{ top: ... }}' from React
    position: 'static !important', 
    top: 'auto !important',
    left: 'auto !important',
    transform: 'none !important',

    // 2. FILL THE EXPERIMENT AREA
    width: '100% !important',
    height: '100% !important',
    minWidth: '0 !important',
    maxWidth: 'none !important',
    
    // 3. REMOVE VISUALS (Let ExperimentArea handle the rounded frame)
    // boxShadow: 'none',
    boxShadow: '$lg',
    borderRadius: '16px',
    
    // 4. ENABLE SCROLLING
    // If the form is taller than 45vh, let it scroll internally
    overflowY: 'auto',
    

  }
})

export const TimelinePopupHeader = styled('header', {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    background: '$blueWeeks',
    columnGap: '1rem',
    paddingLeft: '1.5rem',
    paddingTop: '0.75rem',
    paddingRight: '1.5rem',
    paddingBottom: '0.75rem',
    boxSizing: 'border-box',
    borderBottom: '0.0625rem solid $separator',
  })
  
  export const HeaderLeft = styled('div', {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
  })
  
  export const HeaderCenter = styled('div', {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    justifySelf: 'center',
  })
  
  export const HeaderRight = styled('div', {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    justifySelf: 'end',
  })
  
  export const HeaderLabel = styled('span', {
    // color: '$separator',
    // color: '$primary11',
    fontSize: '$md',
    fontWeight: 'bold',
  })

export const IconButton = styled('button', {
  all: 'unset',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',

  '& svg': {
    width: '1.25rem',
    height: '1.25rem',
    stroke: '$separator',     // default grey
    fill: '$separator',
    transition: 'stroke 0.2s, fill 0.2s',
  },

  '&:hover': {
    backgroundColor: '$gray11',
    '& svg': {
      stroke: 'black',
      fill: 'black',
    },
  },
})

export const SlotTypeSelect = styled('button', {
  all: 'unset',
  display: 'inline-flex',   
  alignItems: 'center',
  gap: '0.25rem',
  padding: '0.25rem 0.5rem',
  borderRadius: '4px',
  color: '$gray11',
  backgroundColor: '$gray2',
  cursor: 'pointer',
  '&:hover': { backgroundColor: '$gray3' },
})

export const TimezoneHeader = styled('div', { 
  fontSize: '$md',
  // fontWeight: 'bold',
  // color: '$gray11',
  stroke: '$primary11',
  justifySelf: 'center',
})
export const TimezoneDisplay = styled('div', {
  fontSize: '$md',
  // fontWeight: 'bold',
  // color: '$gray11',
  color: '$primary11',
  justifySelf: 'center',
})

export const FieldGroup = styled('div', {
    display: 'grid',
    rowGap: '1rem',
    paddingLeft: '2rem',
    flexGrow: 1,
    margin: '1.5rem 0',
  })
  
  export const FieldLabel = styled('label', {
    fontSize: '$md',
    fontWeight: 500,
    color: '$gray11',
  })
  
  export const TextInput = styled('input', {
    padding: '0.5rem',
    border: '1px solid $separator',
    borderRadius: '4px',
    fontSize: '$md',
    '&:focus': {
      outline: 'none',
      boxShadow: '0 0 0 2px $gray5',
    },
  })
  
  export const Select = styled('select', {
    padding: '0.5rem',
    border: '1px solid $separator',
    borderRadius: '4px',
    fontSize: '$md',
    backgroundColor: '#ffffff',
    '&:focus': {
      outline: 'none',
      boxShadow: '0 0 0 2px $gray5',
    },
  })
  
  export const Toggle = styled('input', {
    appearance: 'none',
    width: '3rem',
    height: '1.5rem',
    backgroundColor: '$separator',
    borderRadius: '9999px',
    position: 'relative',
    cursor: 'pointer',
    '&::before': {
      content: '',
      position: 'absolute',
      top: '0.15rem',
      left: '0.15rem',
      width: '1.2rem',
      height: '1.2rem',
      backgroundColor: '$loContrast',
      borderRadius: '50%',
      transition: 'transform 0.2s',
    },
    '&::after': {
      content: '"Off"',
      position: 'absolute',
      top: '50%',
      left: '1.8rem',
      transform: 'translateY(-50%)',
      fontSize: '$md',
      color: '$hiContrast',
      pointerEvents: 'none',
    },
    '&:checked': {
      backgroundColor: '$hiContrast',
    },
    '&:checked::before': {
      transform: 'translateX(1.5rem)',
    },
    '&:checked::after': {
      content: '"On"',
      left: '0.5rem',
      color: '$loContrast',
    },
  })
  


export const ClockIcon = styled(FiClock, {
  flexShrink: 0,
//   stroke: '$separator'
  stroke: '$primary11',
})

export const DateTimeRow = styled('div', RowBase)

export const ModifyFreeRow = styled('div', RowBase)


export const ModifyFreeIcon = styled(FiCalendar, {
  flexShrink: 0,
  stroke: '$primary11',
  marginRight: '1.5rem',  
})

export const TuteeRow = styled('div', RowBase)

export const TuteeIcon = styled(FiUser, {
    flexShrink: 0, 
    stroke: '$primary11'
})


export const ToggleOffIcon = styled(FiToggleLeft, {
  width: '1.75rem',
  height: '1.75rem',
  stroke: '$primary11',
  flexShrink: 0,
})

export const ToggleOnIcon = styled(FiToggleRight, {
  width: '1.75rem',
  height: '1.75rem',
  stroke: '$primary11',
  flexShrink: 0,
})


export const DateWrapper = styled('div', {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  })
  
  export const DateInput = styled('input', {
    appearance: 'none',           
    padding: '0.5rem 2.5rem 0.5rem 0.75rem', 
    border: '1px solid $separator',
    borderRadius: '4px',
    fontSize: '$md',
    backgroundColor: '$appBackground', 
    color: '$gray11',
    '&:focus': {
      outline: 'none',
      boxShadow: '0 0 0 2px $gray5',
    },
  })
  
  export const CalendarIcon = styled(FiCalendar, {
    position: 'absolute',
    right: '0.75rem',
    pointerEvents: 'none',
    stroke: '$primary11',
    fill: '$primary11'
  })

  export const RepeatIcon = styled(FiRepeat, {
    flexShrink: 0,
    stroke: '$primary11',
  })

  export const ArrowIcon  = styled(FiArrowRight, {
    // stroke: '$primary11',
    margin: '1.5rem'
  })
  
  export const RepeatRow = styled('div', RowBase)

  export const DateLabel = styled('span', {
    minWidth: '8rem',
    fontSize: '$md',
    lineHeight: '2rem',
    textAlign: 'center',
    // paddingLeft: '0.75rem',   // ← match the dropdown’s internal padding
  })
  

  export const DescriptionIcon = styled(FiEdit3, {
    flexShrink: 0,
    // stroke: '$separator',
    stroke: '$primary11',

  })
  
  export const DescriptionRow = styled('div', {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',         // identical spacing to DateTimeRow / RepeatRow
  })

  export const CardFooter = styled('div', {
    display: 'flex',
    justifyContent: 'space-between', // Pushes buttons to opposite ends
    alignItems: 'center',
    padding: '1rem 1.5rem', // Match horizontal padding of header
    borderTop: '1px solid $elementBorder', // Separator line
    flexShrink: 0,

  });
  
  export const Overlay = styled('div', {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overscrollBehavior: 'none',
  });

  export const Dialog = styled('div', {
    width: 'min(920px, 96dvw)', maxHeight: '90dvh', overflow: 'auto', background: 'white', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.25)', overscrollBehavior: 'none',
  });